"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServSc = void 0;
const base_1 = require("./base");
/**
 * SnapChat Pixel
 */
class AnServSc extends base_1.AnServBase {
    static isLoaded() {
        return (window.snaptr !== undefined);
    }
    static sendInit(pixelId, userId, email, coupon) {
        snaptr("init", pixelId);
        this.logEvent({
            cmd: "init",
            pixelId: pixelId
        });
        return true;
    }
    static sendIdentify(pixelId, userId, email) {
        const initProps = {
            user_email: email
        };
        snaptr("init", pixelId, initProps);
        this.logEvent({
            cmd: "init",
            pixelId: pixelId,
            initProps: initProps
        });
        return true;
    }
    static sendPage(pixelId, tags = null) {
        snaptr("track", "PAGE_VIEW");
        this.logEvent({
            cmd: "track",
            eventName: "PAGE_VIEW"
        });
        return true;
    }
    static sendEventPurchase(price) {
        const trackProps = {
            price: price,
            currency: "USD"
        };
        snaptr("track", "PURCHASE", trackProps);
        this.logEvent({
            cmd: "track",
            eventName: "PURCHASE",
            trackProps: trackProps
        });
        return true;
    }
    static sendEventStartCheckout() {
        snaptr("track", "START_CHECKOUT");
        this.logEvent({
            cmd: "track",
            eventName: "START_CHECKOUT"
        });
        return true;
    }
    static sendEventAddToCart() {
        snaptr("track", "ADD_CART");
        this.logEvent({
            cmd: "track",
            eventName: "ADD_CART"
        });
        return true;
    }
    static sendEventSignup() {
        snaptr("track", "SIGN_UP");
        this.logEvent({
            cmd: "track",
            eventName: "SIGN_UP"
        });
        return true;
    }
}
exports.AnServSc = AnServSc;
AnServSc.serviceName = "Snapchat";
